export const isUserLoggedIn = user => !!user.get('token')



// WEBPACK FOOTER //
// ./src/utils/auth.js